import React, { ReactElement, useCallback } from 'react';

import { Controller, Control } from 'react-hook-form';

import { TextField } from '../tagging';

 

interface Props {
  control: Control<any>;
  name: string;
  component?: any;
  setValue?: any;
  [key: string]: any;
}

function TextWrapper({
  control,
  component: Component = TextField,
  setValue,
  name,
  ...rest
}: Props): ReactElement {
  const renderComponent = useCallback(
    ({ field: { ref, onChange, onBlur, ...fieldState } }) => (
      <Component
        {...fieldState}
        {...rest}
         
        onChange={(event) => {
          onChange(event);
        }}
        onBlur={(event) => {
          const { value } = event.target;
          const trimmedValue = value.trim();
          setValue(name, trimmedValue);
        }}
      />
    ),
    [Component, rest, name, setValue],
  );

  return <Controller name={name} control={control} render={renderComponent} />;
}

export default TextWrapper;
